export const VoterVoiceContent = ({ voterVoiceUrl }: { voterVoiceUrl: string }) => {
  // Make sure url has '?hideAlert=true' appended to it
  let newUrl = voterVoiceUrl
  if (!newUrl.includes('?hideAlert=true')) {
    newUrl = `${newUrl}?hideAlert=true`
  }

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col rounded-2xl bg-neutral-50">
      <iframe src={newUrl} width="100%" className="min-h-0 w-full flex-1"></iframe>
    </div>
  )
}
